import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import '../../styles/HeroCustom.scss';
import BackgroundSlider from './BackgroundSlider';
import AnimatedText from './AnimatedText';

const HeroCustom: React.FC = () => {
  const { t } = useTranslation();

  return (
    <div className="hero-container position-relative">
      {/* Background Slider */}
      <BackgroundSlider />

      {/* Gold Gradient Overlay (left) */}
      <div className="hero-gradient-overlay" />

      {/* Main Content (text) */}
      <div className="hero-content">
        <AnimatedText 
          text={t('home.hero.title')}
          delay={100}
          repeatDelay={3000}
        />
      </div>

      {/* White Slanted Bottom Div */}
      {/* <div className="hero-bottom-white" /> */}

      {/* Floating 3-Box Row */}
      <div className="hero-floating-boxes py-2">
        <div className="hero-box menu-item">
          <Link to="/services#international-freight" className="text-decoration-none">
            <img src="/images/Icons/international-shipping.png" alt="International Shipping" className="image-hover-animation" />
            <div>{t('home.hero.box1')}</div>
          </Link>
        </div>
        <div className="hero-box menu-item">
          <Link to="/services#warehouse" className="text-decoration-none">
            <img src="/images/Icons/warehousing.png" alt="Warehouses" className="image-hover-animation" />
            <div>{t('home.hero.box2')}</div>
          </Link>
        </div>
        <div className="hero-box menu-item">
          <Link to="/services#customs-clearance" className="text-decoration-none">
            <img src="/images/Icons/customs.png" alt="Customs Clearance Broker" className="image-hover-animation" />
            <div>{t('home.hero.box3')}</div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default HeroCustom; 